var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-icon-text",attrs:{"disabled":_vm.loading}},[(_vm.loading)?_c('spinner',{staticClass:"spinner",attrs:{"size":"small"}}):_c('svgicon',{attrs:{"name":_vm.icon,"fill":false}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-151340be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/ButtonIconTextLoading.vue
// module id = null
// module chunks = 